module.exports = __webpack_public_path__ + "img/2024-03-19e_2.5e777a4d.jpg";